import {TweenLite} from "gsap";
import {Layers, OktoberfestLayers} from "./OktoberfestLayers";
import {Oktoberfest} from "../Oktoberfest";
import {OktoberfestGameConfig} from "../OktoberfestGameConfig";
import {GameHelper} from "../../core/utils/GameHelper";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";

/**
 * Created by Shikha on 09/13/2021.
 */


export class OktoberfestReelDividers extends PIXI.Container {
    public static toPlayAttentionOnReel1: boolean = false;
    protected _normalContainer: PIXI.Container;
    protected _normalDividers: PIXI.Container[];
    private _chainSpinStep: number = 20;
    private _currentChainStep: number;
    private _dividerChainNormal: PIXI.Sprite;
    private _dividerChainTween: TweenLite;
    private _chainMaxOffset: number = 411;
    private _freespinIntroPanningXTween: TweenLite;

    private _sideChain: PIXI.Sprite;
    private _sideChainRadians: number = 10 / 180 * Math.PI;
    private _sideChainStartX: number = -305;
    private _sideChainStartY: number = 540;

    private _cogs: TimelineSprite;

    private _isSpinning: boolean;
    private _sideChainTween: TweenLite;
    private _currentSideChainStepX: number;
    private _currentSideChainStepY: number;
    private _sideChainMaxOffsetY: number;
    private _posXPortrait: number = 34;
    private _posYPortrait: number = 67;
    private _scaleYChain: number = 0.9;
    public _desktopXPos: number = 0;

    constructor() {
        super();
        this._sideChainMaxOffsetY = ( this._chainMaxOffset ) * Math.cos(this._sideChainRadians);
        this._isSpinning = false;
        this.initAnimations();
        OktoberfestLayers.getLayer(Layers.REEL_ATTENTION)!.addChild(this);
        this.onResize();
    }

    public setDesktopPos(val: number): void {
        if(GameHelper.isDesktop()) {
            this._desktopXPos = val;
        }
    }

    public onResize(): void {
        let defaultScale: number = OktoberfestGameConfig.GAME_WIDTH / 1432;
        this._normalContainer.position.y = 80;
        this._scaleYChain = 0.9;
        const isDesktop: boolean = GameHelper.isDesktop();

        if(NolimitApplication.isLandscape) {
            defaultScale = 1;
            this._posXPortrait = 0;
            this._posYPortrait = 0;
            this._chainMaxOffset = 411;
        }else{
            this._posXPortrait = 34;
            this._posYPortrait = 67;
            this._chainMaxOffset = 80;
        }

        OktoberfestLayers.getLayer(Layers.LOW_SYMBOLS)!.scale.set(defaultScale);
        OktoberfestLayers.getLayer(Layers.LOW_SYMBOLS)!.x = isDesktop ? this._desktopXPos : this._posXPortrait;
        OktoberfestLayers.getLayer(Layers.LOW_SYMBOLS)!.y = this._posYPortrait;

        OktoberfestLayers.getLayer(Layers.HIGH_SYMBOLS)!.scale.set(defaultScale);
        OktoberfestLayers.getLayer(Layers.HIGH_SYMBOLS)!.x = isDesktop ? this._desktopXPos : this._posXPortrait;
        OktoberfestLayers.getLayer(Layers.HIGH_SYMBOLS)!.y = this._posYPortrait;

        OktoberfestLayers.getLayer(Layers.LOW_SYMBOLS_WIN)!.scale.set(defaultScale);
        OktoberfestLayers.getLayer(Layers.LOW_SYMBOLS_WIN)!.x = isDesktop ? this._desktopXPos : this._posXPortrait;
        OktoberfestLayers.getLayer(Layers.LOW_SYMBOLS_WIN)!.y = this._posYPortrait;

        OktoberfestLayers.getLayer(Layers.HIGH_SYMBOLS_WIN)!.scale.set(defaultScale);
        OktoberfestLayers.getLayer(Layers.HIGH_SYMBOLS_WIN)!.x = isDesktop ? this._desktopXPos : this._posXPortrait;
        OktoberfestLayers.getLayer(Layers.HIGH_SYMBOLS_WIN)!.y = this._posYPortrait;

        OktoberfestLayers.getLayer(Layers.REEL_ATTENTION)!.scale.set(defaultScale);
        OktoberfestLayers.getLayer(Layers.REEL_ATTENTION)!.x = isDesktop ? this._desktopXPos : this._posXPortrait;

        OktoberfestLayers.getLayer(Layers.REEL_BACKGROUND)!.scale.set(defaultScale);
        OktoberfestLayers.getLayer(Layers.REEL_BACKGROUND)!.x = 6;

        OktoberfestLayers.getLayer(Layers.GLOW_DIVIDERS)!.scale.set(defaultScale);
        OktoberfestLayers.getLayer(Layers.GLOW_DIVIDERS)!.x = this._posXPortrait;

        OktoberfestLayers.getLayer(Layers.PRETZEL_PARTY_WIN)!.scale.set(defaultScale);
        OktoberfestLayers.getLayer(Layers.PRETZEL_PARTY_WIN)!.x = this._posXPortrait;
        OktoberfestLayers.getLayer(Layers.PRETZEL_PARTY_WIN)!.y = this._posYPortrait;

        OktoberfestLayers.getLayer(Layers.WILD_3_LAYER)!.y = this._posYPortrait;

        OktoberfestLayers.getLayer(Layers.BETLINES)!.scale.set(defaultScale);
        OktoberfestLayers.getLayer(Layers.BETLINES)!.x = this._posXPortrait;
        OktoberfestLayers.getLayer(Layers.BETLINES)!.y = this._posYPortrait;

        this._dividerChainNormal.y = -this._chainMaxOffset;
    }

    public onSpinStart(): void {
        this._isSpinning = true;
        this.setChainSpeed(this._chainSpinStep);
        this.playAllChainsAnimation();
        if (OktoberfestReelDividers.toPlayAttentionOnReel1) {
            Oktoberfest.nearWinView.onPlayReelNearWinAttention(0);
        }
    }

    public onReelStop(reelId: number): void {
        if (reelId === 4) {
            this._isSpinning = false;
            this._cogs.stopLoop();
            this._dividerChainTween.kill();
            this._sideChainTween.kill();
            this.onDividerChainPositionUpdate();
            this.onSideChainPositionUpdate();
        }
    }

    public onFreeSpinIntroPanning(duration: number): void {
        this._freespinIntroPanningXTween =
            TweenLite.to(
                [
                    OktoberfestLayers.getLayer(Layers.LOW_SYMBOLS)!,
                    OktoberfestLayers.getLayer(Layers.HIGH_SYMBOLS)!,
                    OktoberfestLayers.getLayer(Layers.LOW_SYMBOLS_WIN)!,
                    OktoberfestLayers.getLayer(Layers.HIGH_SYMBOLS_WIN)!,
                    OktoberfestLayers.getLayer(Layers.REEL_ATTENTION)!,
                ], duration, {
                    x: -OktoberfestGameConfig.FREESPIN_INTRO_BACKGROUND_OFFSET
                });
    }

    public onFreespinOutroViewShow(): void {
        Oktoberfest.reelDividers.setDesktopPos(0);
        TweenLite.to(
            [
                OktoberfestLayers.getLayer(Layers.LOW_SYMBOLS)!,
                OktoberfestLayers.getLayer(Layers.HIGH_SYMBOLS)!,
                OktoberfestLayers.getLayer(Layers.LOW_SYMBOLS_WIN)!,
                OktoberfestLayers.getLayer(Layers.HIGH_SYMBOLS_WIN)!,
                OktoberfestLayers.getLayer(Layers.REEL_ATTENTION)!,
            ], 0.001, {
                x: this._posXPortrait
            });

        OktoberfestLayers.getLayer(Layers.BETLINES)!.visible = true;
    }

    protected initAnimations(): void {
        this._normalContainer = new PIXI.Container();
        this._normalDividers = [];
        this.addChild(this._normalContainer);
        let positionsX: number[] = OktoberfestGameConfig.reelDividerPosX;
        for (let i: number = 0; i < positionsX.length; i++) {
            let normalDivider: PIXI.Container = this.createNormalDivider(i);
            normalDivider.x = positionsX[i];
            normalDivider.y = -73;
            this._normalContainer.addChild(normalDivider);
            this._normalDividers.push(normalDivider);
        }

        this._sideChain = new PIXI.Sprite(this.createChainTexture("chainPart"));
        this._sideChain.anchor.set(0.5, 1);
        this._sideChain.x = this._sideChainStartX;
        this._sideChain.y = this._sideChainStartY;
        this._sideChain.rotation = this._sideChainRadians;
        this._normalContainer.addChild(this._sideChain);

        this._cogs = new TimelineSprite(Oktoberfest.assetLoader.getTextures("reel-cogs"));
        this._cogs.anchor.set(0.5);
        this._cogs.position.set(-210, 80);
        this._normalContainer.addChild(this._cogs);
    }

    protected createNormalDivider(index: number): PIXI.Container {
        let sprite: PIXI.Sprite = new PIXI.Sprite(Oktoberfest.assetLoader.getTextures("reelDivider")[0]);
        if (index === 0) {
            this._dividerChainNormal = sprite;
            this._dividerChainNormal.texture = this.createChainTexture("chainPart");
        }
        sprite.anchor.x = 0.5;
        sprite.name = "divider" + index;
        return sprite;
    }

    private playAllChainsAnimation() {
        this._cogs.playLoop();
        this.playDividerChainAnimation();
        this.playSideChainAnimation();
    }

    private playSideChainAnimation() {
        if (!this._isSpinning) {
            return;
        }
        this._sideChainTween = TweenLite.to(this._sideChain, 0.1, {
            x: this._sideChain.x - this._currentSideChainStepX,
            y: this._sideChain.y + this._currentSideChainStepY,
            onUpdate: () => this.onSideChainPositionUpdate(),
            onComplete: () => this.playSideChainAnimation()
        });
    }

    private setChainSpeed(speed: number): void {
        this._currentChainStep = speed;
        this._currentSideChainStepX = speed * Math.sin(this._sideChainRadians);
        this._currentSideChainStepY = speed * Math.cos(this._sideChainRadians);
    }

    private onSideChainPositionUpdate() {
        if (this._sideChain.y >= this._sideChainStartY + ( this._sideChainMaxOffsetY )) {
            this._sideChainTween.kill();
            this._sideChain.y -= this._sideChainMaxOffsetY;
            this._sideChain.x = this._sideChainStartX - ( this._sideChain.y - this._sideChainStartY ) * Math.tan(this._sideChainRadians);
            this.playSideChainAnimation();
        }
    }

    private playDividerChainAnimation(): void {
        // the kill tween doesn't work sometime when spin stop, so use this boolean to double check.
        if (!this._isSpinning) {
            return;
        }
        this._dividerChainNormal.scale.y = this._scaleYChain;
        this._dividerChainTween = TweenLite.to(this._dividerChainNormal, {
            duration: 0.1,
            y: this._dividerChainNormal.y - this._currentChainStep+10,
            onUpdate: () => this.onDividerChainPositionUpdate(),
            onComplete: () => this.playDividerChainAnimation()
        });
    }

    private onDividerChainPositionUpdate(): void {
        if (this._dividerChainNormal.y <= 0 - this._chainMaxOffset) {
            this._dividerChainTween.kill();
            this._dividerChainNormal.y += this._chainMaxOffset;
            this.playDividerChainAnimation();
        }
    }

    private createChainTexture(textureName: string): PIXI.Texture {
        let chainPartContainer: PIXI.Container = new PIXI.Container();
        let resolution: number = ( Oktoberfest.assetLoader.getTextures(textureName)[0] ).baseTexture.resolution;

        for (let i: number = 0; i < 8; i++) {
            let chainPartSprite: PIXI.Sprite = new PIXI.Sprite(( Oktoberfest.assetLoader.getTextures(textureName)[0] ));
            chainPartSprite.y = ( i * chainPartSprite.height );
            chainPartContainer.addChild(chainPartSprite);
        }
        return GameHelper.createRenderedTextureFromContainer(chainPartContainer, resolution);
    }

}
